import PopupBasicLazy from 'src/game/components/popups/PopupBasicLazy';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import View from '@play-co/timestep-core/lib/ui/View';
import sounds from 'src/lib/sounds';
import { Feature } from 'src/replicant/analytics';
import { AssetGroup } from '@play-co/timestep-core';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { ImageScaleView } from '@play-co/timestep-core/ui';
import { downscale } from 'src/conf/scale';

type CloseHandler = () => void;

export default class PopupFriendsTutorial extends PopupBasicLazy {
  private message2: LangBitmapFontTextView;

  constructor(opts: { superview: View; close: CloseHandler }) {
    super({
      zIndex: 10000,
      width: 560,
      height: 688,
      superview: opts.superview,
      close: opts.close,
      tracking: {
        feature: Feature.FRIENDS._,
        $subFeature: Feature.FRIENDS.POPUP_TUTORIAL,
      },
    });

    this.message.updateOpts({
      size: 26,
      width: this.box.style.width - 40,
      height: 200,
      x: 20,
      y: 40,
    });

    this.message2 = new LangBitmapFontTextView({
      superview: this.box,
      width: this.box.style.width - 40,
      height: 200,
      x: 20,
      y: this.box.style.height - 290,
      align: 'center',
      verticalAlign: 'center',
      size: 25,
      color: '#9A7171',
      wordWrap: true,
      font: 'Body',
      canHandleEvents: false,
    });

    // Main tutorial image
    new ImageScaleView({
      superview: this.box,
      image: 'assets/ui/friends/tutorial.png',
      scaleMethod: 'contain',
      x: this.box.style.width / 2,
      y: this.box.style.height / 2 - 20,
      width: downscale(738),
      height: downscale(318),
      centerOnOrigin: true,
    });

    // Close button
    new ButtonScaleViewWithText({
      superview: this.box,
      ...uiConfig.buttons.secondary,
      labelOffsetY: -1,
      fontSize: 46,
      font: 'Body',
      x: this.box.style.width / 2,
      y: this.box.style.height - 85,
      width: 259,
      height: 100,
      centerOnOrigin: true,
      localeText: () => i18n('basic.ok'),
      onClick: async () => {
        sounds.sfx.play('ok');
        opts.close();
      },
      tracking: {
        feature: Feature.FRIENDS._,
        $subFeature: Feature.FRIENDS.POPUP_TUTORIAL_OK,
      },
    });
  }

  public getAssetsGroup() {
    return new AssetGroup(['assets/ui/friends/tutorial.png']);
  }

  public init(opts: { tab?: 'search' | 'requests' }) {
    super.init({
      title: i18n('friends.title'),
      message: i18n('friends.tutorial.message1'),
    });
    this.message2.localeText = () => i18n('friends.tutorial.message2');
  }
}
